import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";

import { DevForm } from "@components/Forms/Fields";

export function CountriesPresets({ apiData, setApiData, disabled = false, getPresetData, prefix }) {
    const [activePreset, setActivePreset] = useState({});
    const presetData = getPresetData(apiData);

    useEffect(() => {
        if (presetData) {
            const newActivePreset = { ...activePreset };
            Object.keys(presetData).forEach((preset) => {
                newActivePreset[preset] = true;
                presetData[preset].countries.forEach((field) => {
                    if (apiData.forms_data[prefix].data[field] !== true) {
                        newActivePreset[preset] = false;
                    }
                });
            });
            setActivePreset(newActivePreset);
        }
    }, [JSON.stringify(apiData.forms_data?.[prefix].data)]);

    const setPreset = (preset) => {
        const newApiData = { ...apiData };
        presetData[preset].countries.forEach((field) => {
            newApiData.forms_data[prefix].data[field] = !activePreset[preset];
        });
        setApiData(newApiData);
    };

    const DrawPreset = ({ pr }) => {
        return (
            presetData && (
                <>
                    <Button
                        size="sm"
                        variant={activePreset[pr] ? "success" : "outline-success"}
                        disabled={disabled}
                        onClick={() => setPreset(pr)}
                    >
                        {presetData[pr].name}
                    </Button>{" "}
                </>
            )
        );
    };

    return (
        <>
            <DrawPreset pr="russia" />
            <DrawPreset pr="ww" />
            <DrawPreset pr="asia" />
            <DrawPreset pr="africa" />
            <DrawPreset pr="oceania" />
            <DrawPreset pr="europe" />
            <DrawPreset pr="america" />
        </>
    );
}

export function CountriesBareForm({ prefix = "main", apiData, setApiData, makeDiff }) {
    const [colData, setColData] = useState([]);
    const colNumber = 4;

    useEffect(() => {
        if (apiData.forms_data) {
            const form = apiData.forms_data[prefix];
            const max_in_col = Math.ceil(form.ordered_fields.length / colNumber);
            const cols = [];
            for (let i = 0; i < form.ordered_fields.length; i += max_in_col) {
                const slc = form.ordered_fields.slice(i, i + max_in_col);
                cols.push(slc);
            }
            setColData(cols);
        }
    }, [apiData.forms_data && apiData.forms_data[prefix].ordered_fields]);

    if (!(apiData.forms_data && apiData.forms_data[prefix])) {
        return;
    }

    return (
        colData.length > 0 &&
        [...Array(colData[0].length).keys()].map((row_n) => (
            <Row key={`row_${row_n}`}>
                {[...Array(colNumber).keys()].map((col_n) => {
                    const name = colData[col_n][row_n];

                    let colStyle = {};
                    if (makeDiff) {
                        if (makeDiff.add.includes(parseInt(name))) {
                            colStyle = { backgroundColor: "#2baa45" };
                        }
                        if (makeDiff.del.includes(parseInt(name))) {
                            colStyle = { backgroundColor: "#eb8088" };
                        }
                    }

                    return (
                        <Col key={`col_${row_n}_${col_n}`} style={colStyle}>
                            {name && (
                                <DevForm.Field
                                    prefix={prefix}
                                    apiData={apiData}
                                    setApiData={setApiData}
                                    name={name}
                                    bareControl={true}
                                />
                            )}
                        </Col>
                    );
                })}
            </Row>
        ))
    );
}
